import React from 'react';
import { useTenant } from '../../../context/TenantContext';
import { parseEm } from '../inlineEm';
import { REVISE_ANCHORS } from './sectionMeta';

/* Not on the shipped page since v4 — the giveaway folded into the Practice
 * Labs section as ruled notes, where it reads as part of the product rather
 * than a separate pitch. Kept registered so a tenant can put it back, but it
 * carries NO default copy any more: if this renders, every word came from
 * `branding.marketing.gifts`. */

/** Accent per card, matching the lab each giveaway belongs to. */
const CARD_ACCENTS = ['practice', 'study'] as const;

/** The "what's free" section — the offer, stated as two cards. */
export const ReviseGifts: React.FC = () => {
  const { tenant } = useTenant();
  const gifts = tenant?.branding.marketing?.gifts;

  const items = gifts?.items ?? [];
  if (items.length === 0) return null;

  const { eyebrow, heading = '', lede, foot } = gifts ?? {};

  return (
    <section className="rv-sec" id={REVISE_ANCHORS.gifts} data-accent="practice">
      <div className="rv-wrap">
        <div className="rv-head">
          {eyebrow && <p className="rv-kicker">{eyebrow}</p>}
          {heading && <h2>{parseEm(heading)}</h2>}
          {lede && <p className="rv-lede">{lede}</p>}
        </div>

        <div className="rv-gifts">
          {items.map((gift, i) => (
            <div className="rv-gift" key={gift.title} data-accent={CARD_ACCENTS[i % CARD_ACCENTS.length]}>
              {gift.tag && <span className="rv-tag">{gift.tag}</span>}
              <h3>{gift.title}</h3>
              {gift.body.map((para) => (
                <p key={para.slice(0, 40)}>{para}</p>
              ))}
              {gift.who && <span className="rv-who">{gift.who}</span>}
            </div>
          ))}
        </div>

        {foot && <p className="rv-gifts-foot">{parseEm(foot)}</p>}
      </div>
    </section>
  );
};
